<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6">
                                <label for="batch_id" class="col-form-label col-form-label-sm">Select Batch <span style="color: red">*</span></label>
                                <select
                                        v-model="search_data.batch_id"
                                        id="batch_id"
                                        name="batch_id"
                                        v-validate="'required'"
                                        class="form-control form-control-sm">
                                    <option :value="''" selected>Select Batch</option>
                                    <option
                                            v-for="(batch, index) in batches"
                                            :key="index"
                                            :value="batch.id">
                                        {{batch.trade.desc + " | " + "Batch No: " + batch.batch_no }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Please Select Batch
                                </div>
                            </div>
                            <div class="col-md-6 custom-search">
                                <button class="btn btn-success btn-sm custom-search-button" @click.prevent="search">Search</button>
                            </div>
                        </div>
                    </form>
                </b-card>

                <b-card>
                    <div v-if="batch_data.length > 0" class="row mb-2">
                        <div class="col-sm-10">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ batch_data.length }}</span>
                        </div>
                    </div>

                    <div class="scrollable-table table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Date</th>
                                <th>Total Attend</th>
                                <th>Total Absent</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(batch, index) in batch_data" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ customDate(batch.attendance_date) }}</td>
                                <td>{{ batch.total_attend }}</td>
                                <td>{{ batch.total_absent }}</td>
                                <td>
                                    <span v-if="userPermission.includes('attendance-delete')">
                                        <a href="javascript:void(0);"
                                           class="action-icon" title="Delete batch" @click="onDelete(batch.batch_id, batch.attendance_date, index)">
                                            <i class="mdi mdi-delete deleteButton"></i>
                                        </a>
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <h5 v-if="batch_data.length === 0" class="text-center text-secondary">
                        No Data Found
                    </h5>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";
    import moment from "moment";

    export default {
        page: {
            title: "List of Batch Attendance",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: "Search Trainee",
                items: [
                    {
                        text: "Trainee",
                        href: "/"
                    },
                    {
                        text: "Dashboard",
                        active: true
                    }
                ],
                batch_data: {},
                search_data: {
                    batch_id: '',
                },
                batches: [],
                flag: false,
            };
        },

        mounted() {
            this.getBatches();
        },
        methods: {
            customDate(date) {
                return moment(date).format("LL");
            },
            onDelete(batch_id, attendance_date, index) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/trainee/attendance/delete/" + batch_id + '/' + attendance_date).then(response => {
                        this.batch_data.splice(index, 1);
                        this.$bvToast.toast(response.data.message, {
                            title: "Success",
                            autoHideDelay: 5000,
                            variant: "success"
                        });
                    });
                }
            },
            search() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/trainee/attendance/list", this.search_data)
                            .then(response => {
                                if (!response.error) {
                                    this.flag = true;
                                    this.batch_data = response.data.batch_data;
                                }
                            });
                    }
                });
            },
            getBatches() {
                http.get("api/batch/trainee/getBatch").then(response => {
                    if (!response.error) {
                        this.batches = response.data.batches;
                    }
                });
            },
        },
        computed: {
            userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>

<style>
    .scrollable-table {
        overflow-x: auto;
        white-space: nowrap;
    }
    @media only screen and (min-width: 768px)  {
        .custom-search{
            margin-top: 30px;
        }
    }

    @media only screen and (max-width: 768px)  {
        .custom-search-button{
            margin-top: 8px;
        }
    }

    @media only screen and (max-width: 414px)  {
        .custom-search-button{
            margin-top: 8px;
        }
    }
</style>